import { t as d } from "../../arrow-D3W5NBRc.js";
function x(n) {
  return n.toArray().map((t) => {
    const e = {};
    return n.schema.fields.forEach((o, r) => {
      e[o.name] = t[r];
    }), e;
  });
}
function m(n, t) {
  const e = n.schema.fields.findIndex((o) => o.name === t);
  if (e === -1)
    throw new Error(`Column '${t}' not found in table`);
  return n.getChildAt(e);
}
function A(n, t) {
  return n.select(t);
}
function p(n, t) {
  const e = m(n, t);
  return Array.from(e.toArray());
}
function E(n) {
  return [n.numRows, n.numCols];
}
function h(n) {
  let t = 0;
  for (let e = 0; e < n.length; e++) {
    const o = n.get(e);
    typeof o == "number" && (t += o);
  }
  return t;
}
function w(n) {
  return h(n) / n.length;
}
function S(n, t) {
  const e = t || n.schema.fields.map((r) => r.name), o = {};
  return e.forEach((r) => {
    const s = m(n, r);
    o[r] = h(s);
  }), o;
}
function v(n) {
  const t = {};
  return Object.entries(n).forEach(([e, o]) => {
    t[e] = Math.round(o);
  }), t;
}
function M(n, t, e) {
  const o = m(n, t), r = /* @__PURE__ */ new Map();
  for (let c = 0; c < n.numRows; c++) {
    const i = o.get(c);
    r.has(i) || r.set(
      i,
      e.map(() => [])
    );
    const f = r.get(i);
    e.forEach((a, u) => {
      const l = m(n, a).get(c);
      typeof l == "number" && f[u].push(l);
    });
  }
  const s = [];
  return r.forEach((c, i) => {
    const f = { [t]: i };
    e.forEach((a, u) => {
      f[a] = c[u].reduce((l, g) => l + g, 0);
    }), s.push(f);
  }), s;
}
function T(n) {
  let t = -1 / 0, e = 0;
  for (let o = 0; o < n.length; o++) {
    const r = n.get(o);
    typeof r == "number" && r > t && (t = r, e = o);
  }
  return e;
}
function I(n, t) {
  const e = [];
  for (let o = 0; o < n.length; o++)
    e.push(t(n.get(o), o));
  return e;
}
function b(n) {
  return Array.from(n.toArray());
}
function C(n) {
  return n.schema.fields.map((t) => t.name);
}
function R(n) {
  const t = C(n), e = {};
  return t.forEach((o) => {
    e[o] = p(n, o);
  }), {
    columns: t,
    data: e,
    length: n.numRows
  };
}
function V(n, t, e, o) {
  let r = n;
  return e.forEach(([s, c]) => {
    if (r.schema.fields.find((u) => u.name === s))
      return;
    const f = [];
    for (let u = 0; u < t.length; u++)
      f.push(c(t[u], u));
    const a = d({ [s]: f });
    r = r.assign(a), o?.afterAddColumn?.(s, f);
  }), r;
}
export {
  T as argMax,
  V as generateColumnsIfMissing,
  m as getColumn,
  C as getColumnNames,
  p as getColumnValues,
  E as getTableShape,
  M as groupByAndSum,
  v as roundColumnSums,
  A as selectColumns,
  S as sumColumns,
  x as tableToJSON,
  R as tableToSerializable,
  I as vectorMap,
  w as vectorMean,
  h as vectorSum,
  b as vectorToArray
};
